<script lang="ts" setup>
import { useToast } from "primevue/usetoast"
import { onMounted } from "vue"

import { setGlobalToastNotifier } from "@/utils/graphqlToastNotifier"

onMounted(() => {
  const toast = useToast()
  setGlobalToastNotifier((message) => {
    toast.add({
      ...message,
      life: message.life ?? 6000,
    })
  })
})
</script>

<template>
  <span
    aria-hidden="true"
    class="hidden"
  />
</template>
